import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

export default function useFormatDate() {
  const moment = inject('moment');

  const { locale } = useI18n();

  const userLocale = Intl.DateTimeFormat().resolvedOptions().locale;

  function formatDate(date, { parseZone = true, withTime = true } = {}) {
    date = new Date(parseZone ? moment.parseZone(date).format('YYYY-MM-DDTHH:mm') : date);

    const options = {
      day: 'numeric',
      month: 'short',
      weekday: 'short',
    };

    if (withTime) {
      options.hour = 'numeric';
      options.minute = 'numeric';
    }

    const isPastYear = date.getFullYear() < new Date().getFullYear();
    if (isPastYear) {
      options.year = 'numeric';
    }

    return new Intl.DateTimeFormat([userLocale, locale.value], options).format(date);
  }

  return {
    formatDate,
  };
}
